<template>
	<div class="maskCon">
		<div class="content1">
			<!-- <swiper class="content1" :options="Aoptions">
				<swiper-slide v-for="item in imgList" class="outQ">
					<img :src="item"  >
				</swiper-slide>
				
			</swiper> -->
			
			<el-carousel class="content1" indicator-position="none" :loop="false"
			     :interval="interval" @change="indexChange">
				<el-carousel-item v-for="item in imgList" class="outQ">
					<img :src="item"  >
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				autoplay:false,interval:1000,
				current: 0,
				ss: 0,
				start: null,
				last: null,
				touching: false,
				temp: 0,
				backgroundColor: 'rgba(0,0,0,0)',
				backgroundImage: null,
				nowIndex:0,
				timeS:null,
				Aoptions:{
					effect: 'fade',
					loop:false,
					autoplay:{
						delay: 1000, 
						disableOnInteraction: true,},
				}
			}
		},
		props:{
			isShow:{
				type:Boolean,
				default:true
			},
			imgList:{
				type:Array,
			}
		},
		methods:{
			indexChange(e){
				let len = this.imgList.length
				if(e==len-1){
					setTimeout(()=>{
						this.$emit('close')
					},1000)
				}
			}
		}
		
	}
</script>

<style lang="scss" scoped>
	.van-swipe__track{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.outQ{
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 98vw;
		}
	}
	.img22{
		width: 80vw;
	}
	.imgA{
		width: 50vw;
	}
	.maskCon{
		position: fixed;
		top: 0;left: 0;
		right: 0;bottom: 0;
		background: rgba(0,0,0,0.5);
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.content1{
		width: 100vw;
		height: 100vh;
		// display: flex;
		// align-items: center;
		// justify-content: center;
		// width: 100vw;height: 100vh;
	}
	.imgA{
		z-index: 0;
		position: absolute;
		width: 270px;
		box-shadow: -3px 5px 3px rgba(0, 0, 0, 0.3);
	}
	.con {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	
		.stage {
			width: 120vw;
			display: block;
			position: absolute;
			perspective: 800px;
			display: flex;align-items: center;
			justify-content: center;
			// background-color: blue;
		}
	
		.back {
			position: absolute;
			width: 100%;
		}
	
		.box {
			transform-style: preserve-3d;
			position: relative;
			width: 240px;
			
			display: flex;
			align-items: center;
			justify-content: center;
	
			.title {
				position: absolute;
				width: 240px;
				height: 36px;
				font-size: 28px;
			}
	
			image {
				z-index: 0;
				position: absolute;
				width: 270px;
				height: 500px;
				box-shadow: -3px 5px 3px rgba(0, 0, 0, 0.3);
			}
	
			.vrect-image {
				height: 416px;
			}
	
			.hrect-image {
				height: 45vh;
			}
		}
	
		.slow {
			transition-duration: 1s;
		}
	}
</style>